export const referrerHostUrls = {
    'microsoft365.com/copilot': 'm365copilot',
    'm365.cloud.microsoft': 'mcmcopilot',
    'copilot.cloud.microsoft': 'ccmcopilot',
    'microsoft365.com/chat': 'm365chat',
    'office.com/chat': 'officechat',
};
export const defaultReferrer = 'defaultReferrer';
//# sourceMappingURL=index.js.map